<template>
  <div>
    <ol class="breadcrumb">
      <div id="tp">
        <ul class="list-inline">
          <li class="list-inline-item">Техническая поддержка:&nbsp;</li>
          <li class="list-inline-item"><a href="tel:+7 (495) 937-4742"><i class="fa fa-phone"></i> +7 (495) 937-4742</a>&nbsp;</li>
          <li class="list-inline-item"><a href="mailto:info@exportedu.ru"><i class="fa fa-envelope-o"></i> info@exportedu.ru</a>&nbsp;</li>
        </ul>
      </div>
      <li class="breadcrumb-item" :key="index" v-for="(routeObject, index) in routeRecords">
      <span class="disallow" v-if="isDiagnost(index) && isLast(index)">
        <router-link :to="'/dashboard?status=candidate'">Кандидаты</router-link>&nbsp;
      </span>
      <span class="disallow" v-if="isReport(index) && isLast(index)">
        <router-link :to="'/dashboard?status=candidate'">Кандидаты</router-link>&nbsp;&nbsp;/&nbsp;
        <router-link :to="'/diagnost/' + getId()">Комплексная диагностика</router-link>&nbsp;
      </span>
        <span class="active" v-if="isLast(index)">{{ getName(routeObject) }}</span>
        <router-link :to="routeObject" v-else>{{ getName(routeObject) }}</router-link>
        <directory slug="v-processe-verifikacii" v-if="inVerify(index)" />
        <directory slug="ne-verificirovano" v-if="noVerify(index)" />
        <directory slug="uchastnik-meropriyatiya" v-if="inEvent(index)" />
        <directory slug="kandidat" v-if="inCandidate(index)" />
        <directory slug="zavershili-obuchenie" v-if="isComplete(index)" />
        <directory slug="arhiv" v-if="isArchive(index)" />
      </li>
    </ol>
  </div>
</template>

<script>
    import Directory from "../components/Directory.vue";

    export default {
      components: {Directory},
        props: {
            list: {
                type: Array,
                required: true,
                default: () => []
            }
        },
        computed: {
            routeRecords: function () {
                return this.list.filter((route) => route.name || route.meta.label)
            }
        },
        methods: {
            getName (item) {
              if(item.path === '/dashboard' && this.$route.query.status) {
                if(this.$route.query.status === 'init') {
                  return 'Не верифицировано'
                }
                if(this.$route.query.status === 'verify') {
                  return 'В процессе верификации'
                }
                if(this.$route.query.status === 'event') {
                  return 'Участник мероприятия'
                }
                if(this.$route.query.status === 'candidate') {
                  return 'Кандидат'
                }
                if(this.$route.query.status === 'complete') {
                  return 'Завершили обучение'
                }
                if(this.$route.query.status === 'archive') {
                  return 'Архив'
                }
              } else if(item.path === '/dashboard') {
                return 'Не верифицировано'
              }
                return item.meta && item.meta.label ? item.meta.label : item.name || null
            },
            isLast (index) {
                return index === this.list.length - 1
            },
            isDiagnost(index) {
                return this.list[index].path === '/diagnost/:id';
            },
            inVerify(index) {
              return this.list[index].path === '/dashboard' && this.$route.query.status === 'verify';
            },
            noVerify(index) {
              return this.list[index].path === '/dashboard' && (this.$route.query.status === 'init' || !this.$route.query.status);
            },
            inEvent(index) {
              return this.list[index].path === '/dashboard' && this.$route.query.status === 'event';
            },
            inCandidate(index) {
              return this.list[index].path === '/dashboard' && this.$route.query.status === 'candidate';
            },
            isComplete(index) {
              return this.list[index].path === '/dashboard' && this.$route.query.status === 'complete';
            },
            isArchive(index) {
              return this.list[index].path === '/dashboard' && this.$route.query.status === 'archive';
            },
            isReport(index) {
                return ['/diagnost/:id/form', '/diagnost/:id/factors', '/diagnost/:id/finance', '/diagnost/:id/verify', '/diagnost/:id/interview', '/diagnost/:id/finance-detail', '/diagnost/:id/final'].indexOf(this.list[index].path) > -1;
            },
            getId() {
                return this.$route.params.id;
            }
        }
    }
</script>
<style>
  .disallow:after {
    display: inline-block;
    padding-right: 0.5rem;
    color: #73818f;
    content: "/";
  }
  #tp {
    right: 31px;
    position: absolute;
  }
</style>
